export const LOW_ID = '0'
export const BORDER_ID = '1'
export const HIGH_ID = '2'
export const VERY_HIGH_ID = '3'
export const FAIL_TITLE = 'Fail'
export const PASS_TITLE = 'Pass'

export const SCORE_ITEMS = [
  {
    id: LOW_ID,
    title: 'Low',
  },
  {
    id: BORDER_ID,
    title: 'Border',
  },
  {
    id: HIGH_ID,
    title: 'High',
  },
  {
    id: VERY_HIGH_ID,
    title: 'Very High',
  },
]
